import Analytics from '@opencare/analytics';
import loDebounce from 'lodash/debounce';
import moment from 'moment';
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { UpdatePatientSilently } from 'connect/saga/handlers/update-patient-silently/update-patient-silently';
import { selectDataPatient } from 'connect/selectors';

const analytics = new Analytics();

const RouteListener = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const patient = useSelector(selectDataPatient);

  // Keep a ref to the latest patient so the debounced function never has a
  // stale closure — even if patient loads after the debounce is created.
  const patientRef = useRef(patient);
  useEffect(() => {
    patientRef.current = patient;
  }, [patient]);

  // Stable debounced function for the lifetime of the component.
  // Reads patient via ref so it always sees the current value.
  const tryUpdatePatient = useMemo(() => loDebounce(
    () => {
      if (!patientRef.current?.id) {
        return;
      }

      dispatch(
        UpdatePatientSilently.createAction({
          patientId: patientRef.current.id,
          lastSeenAt: moment.utc().toISOString(),
        }),
      );
    },
    // 5 seconds debounce (do not update more than once every 5 seconds).
    5000,
    {
      // Fire on the leading edge only
      leading: true,
      trailing: false,
    },

  ), [dispatch]);

  useEffect(() => {
    // Track when this useEffect runs
    analytics.trackDefaultPageView();

    const unlisten = history.listen(() => {
      // Track anytime the route changes
      analytics.trackDefaultPageView();

      // Update the patient's last seen at timestamp
      tryUpdatePatient();
    });

    return () => unlisten();
  }, [history, tryUpdatePatient]);

  return props.children;
};

export default RouteListener;
